<section class="flex col a-center j-center">
    <span class="h2-logo-caption">{{ yeshiva }}</span>
    <span class="h5-logo-caption">{{ whyInternet }}</span>
</section>
